import React, { useState } from 'react'
import { enqueueSnackbar } from 'notistack';
import Button1 from '../../form/Button1';
import manualVoid from '../../../controllers/booking/postTicketing/void/manualVoid';

export default function ManualVoid({data,callback}) {
    const [loadings,setLoadings] = useState({submit: false})
    
    async function handleManual() {
        setLoadings({...loadings,submit: true})
        const res = await manualVoid(data?._id);
        setLoadings({...loadings,submit: false})
        if(res.return) {
          enqueueSnackbar('Ticket Voided.',{variant: 'success'})
          callback && callback()
        } else enqueueSnackbar(res.msg,{variant: 'error'})
      }
    
  return (
    <div className='flex flex-col gap-6'>
        <div>
            <h5>Are you sure you want to void this ticket?</h5>
            <p>Please review the request and confirm they are accurate.</p>
        </div>
        <div className='flex gap-4'>
        <div>
            <Button1 variant='outlined'>Cancel</Button1>
        </div>
        <Button1 loading={loadings.submit} onClick={handleManual}>Void</Button1>
        </div>
    </div>
  )
}
